<template>
<div class="home guide-page page separate-containers nav-below-header">
  <HeadNav selectedLanguage="en" page="home" />
  <GuideBreadcrumb :items="[{ label: 'Home', href: '/' }, { label: 'Page not found' }]" />
  <div id="page" class="site grid-container container hfeed">
    <div class="site-content">
      <main class="site-main section-content">
        <h1 class="h">Page not found</h1>
        <p>The URL may be outdated or mistyped. Try these entry points:</p>
        <ul class="check-list">
          <li><a href="/">Home</a></li>
          <li><a href="/download/">Download</a></li>
          <li><a href="/help/">Help center</a></li>
          <li><a href="/blog/">Blog</a></li>
        </ul>
      </main>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/guide-pages.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'

export default {
  name: 'NotFound',
  components: { HeadNav, GuideBreadcrumb },
}
</script>
